import { Icon24ErrorCircle } from '@vkontakte/icons';
import { Text, Title } from '@vkontakte/vkui';
import React, { memo } from 'react';
import { Informer } from 'reactApp/ui/Informer/Informer';
import { EInformerColor } from 'reactApp/ui/Informer/Informer.types';

import styles from './B2BOverquotaWarningInformer.css';

const ICON_SIZE = 36;

export const B2BOverquotaWarningInformer = memo(function B2BOverquotaWarningInformer() {
    return (
        <Informer
            className={styles.root}
            color={EInformerColor.yellow}
            icon={<Icon24ErrorCircle width={ICON_SIZE} height={ICON_SIZE} fill="var(--vkui--color_accent_orange)" />}
            title={
                <Title level="3" className={styles.title}>
                    Файловое хранилище почти заполнено
                </Title>
            }
        >
            <Text className={styles.message}>
                Если оно заполнится полностью, то Почта и Диск заблокируются. Обратитесь к администратору, чтобы сохранить доступ
            </Text>
        </Informer>
    );
});
